import { cx } from './cx';

export interface IllustrationProps {
  src?: string;
  /** Describe the picture; pass '' only when it is purely decorative. */
  alt: string;
  className?: string;
  /** Crop focus, e.g. '60% 40%'. */
  position?: string;
  /** Shown on the soft patterned fallback when the picture does not exist yet. */
  fallbackLabel?: string;
  /** `contain` shows the whole picture (scenes are drawn as arches with transparent corners). */
  fit?: 'cover' | 'contain';
  /** Load straight away (pictures in the first screen); everything else loads lazily. */
  eager?: boolean;
}

/** A hand-drawn illustration, or a calm patterned card when it has not been made yet. */
export const Illustration = ({ src, alt, className = '', position, fallbackLabel, fit = 'cover', eager = false }: IllustrationProps) =>
  src ? (
    <img
      src={src}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      {...(eager ? { fetchpriority: 'high' } : {})}
      className={cx('block h-full w-full', fit === 'contain' ? 'object-contain' : 'object-cover', className)}
      style={position ? { objectPosition: position } : undefined}
    />
  ) : (
    <div
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      className={cx('illustration-fallback flex h-full w-full items-center justify-center p-4 text-center', className)}
    >
      {fallbackLabel && <span className="rounded-sm bg-white/85 px-3 py-1 text-caption text-wood-ink">{fallbackLabel}</span>}
    </div>
  );
